import { FC, Fragment } from "react";
import { Route } from "react-router-dom";
import { ROUTES } from "@constants";
import { CartPage } from "@pages/Cart/CartPage";
import { ConfirmationPage } from "@pages/Confirmation/ConfirmationPage";
import { CustomerDetailsPage } from "@pages/CustomerDetails/CustomerDetailsPage";
import { HomePage } from "@pages/Home/HomePage";
import { SummaryPage } from "@pages/Summary/SummaryPage";
import { i18n } from "@translations/i18n";
import { StepperComponent } from "@common/stepper/StepperComponent";
import { TwoWayAuthPage } from "@pages/TwoWayAuth/TwoWayAuthPage";

enum StepperIndex {
    planSelectionIndex,
    customerDetailIndex,
    summaryIndex,
    confirmationIndex,
}

interface IRoutes {
    component: FC;
    path: string;
    targetStep: StepperIndex;
    title?: string;
}

const objectRoutes: IRoutes[] = [
    {
        component: HomePage,
        path: ROUTES.HOME_PAGE_URL_EN,
        targetStep: StepperIndex.planSelectionIndex,
    },
    {
        component: HomePage,
        path: ROUTES.HOME_PAGE_URL_EL,
        targetStep: StepperIndex.planSelectionIndex,
    },
    {
        component: CartPage,
        path: ROUTES.CART_PAGE_URL_EN,
        targetStep: StepperIndex.planSelectionIndex,
        title: i18n.t("Plan selection"),
    },
    {
        component: CartPage,
        path: ROUTES.CART_PAGE_URL_EL,
        targetStep: StepperIndex.planSelectionIndex,
        title: i18n.t("Plan selection"),
    },
    {
        component: CustomerDetailsPage,
        path: ROUTES.DETAILS_PAGE_URL_EN,
        targetStep: StepperIndex.customerDetailIndex,
        title: i18n.t("Customer details"),
    },
    {
        component: CustomerDetailsPage,
        path: ROUTES.DETAILS_PAGE_URL_EL,
        targetStep: StepperIndex.customerDetailIndex,
        title: i18n.t("Customer details"),
    },
    {
        component: SummaryPage,
        path: ROUTES.SUMMARY_PAGE_URL_EN,
        targetStep: StepperIndex.summaryIndex,
        title: i18n.t("Payment"),
    },
    {
        component: SummaryPage,
        path: ROUTES.SUMMARY_PAGE_URL_EL,
        targetStep: StepperIndex.summaryIndex,
        title: i18n.t("Payment"),
    },
    {
        component: ConfirmationPage,
        path: ROUTES.CONFIRMATION_PAGE_URL_EN,
        targetStep: StepperIndex.confirmationIndex,
        title: i18n.t("Confirmation"),
    },
    {
        component: ConfirmationPage,
        path: ROUTES.CONFIRMATION_PAGE_URL_EL,
        targetStep: StepperIndex.confirmationIndex,
        title: i18n.t("Confirmation"),
    },
    {
        component: TwoWayAuthPage,
        path: ROUTES.TWO_WAY_AUTH_OTP_URL_EN,
        targetStep: 0,
    },
    {
        component: TwoWayAuthPage,
        path: ROUTES.TWO_WAY_AUTH_OTP_URL_EL,
        targetStep: 0,
    },
];

export const Routes = objectRoutes.map(({ component: Component, path, targetStep, title }) => (
    <Route
        exact
        key={path}
        path={path}
        render={() => (
            <Fragment>
                {path !== ROUTES.TWO_WAY_AUTH_OTP_URL_EN && path !== ROUTES.TWO_WAY_AUTH_OTP_URL_EL && (
                    <StepperComponent activeStep={targetStep} title={title} />
                )}
                <Component />
            </Fragment>
        )}
    />
));
